import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ModalService } from 'src/shared/modal/modal.service'
import { DealReferenceNumbersComponent, DealReferenceNumbersDealView, DealReferenceNumbersOptions } from './deal-reference-numbers.component'
import type { DealReferenceRow } from './deal-reference-numbers.component'

@Injectable()
export class DealReferenceNumbersService {
  private modal = inject(ModalService)


  /**
   * @param dealIds – deal ids to show reference numbers for
   * @param dealViews – optional pre-fetched views (e.g. from deal list) to avoid an extra getDealViews call
   * @returns Observable that emits the updated rows when the user saves, or undefined when the dialog is closed without saving
   */
  showDealReferenceNumbers(dealIds: string[], dealViews?: DealReferenceNumbersDealView[]): Observable<DealReferenceRow[] | undefined> {
    return this.modal.openDialog<
      DealReferenceNumbersComponent,
      DealReferenceNumbersOptions,
      DealReferenceRow[]
    >(
      DealReferenceNumbersComponent,
      { dealIds, dealViews },
      { width: 'auto', maxWidth: '95vw', panelClass: ['tc-dialog', 'tc-dialog-fit-content'] },
    )
  }
}
